import SwitcherSimpleView from './SwitcherSimpleView'
export default SwitcherSimpleView
